// Polyfills
import objectFitImages from 'object-fit-images';
// jQuery
import $ from 'jquery';
// Plugins
import simpleParallax from 'simple-parallax-js';
import 'slick-carousel';
import 'magnific-popup';
// Modules
import { navScroll } from './frontend/navScroll';
import { navToggle } from './frontend/navToggle';
import { navDropdown } from './frontend/navDropdown';
import { scrollToPrettyNameElementOrChild } from './frontend/scrollHelper';
import { showHide } from './frontend/showHide';
import { tabs } from './frontend/tabs';
import { stageSlider, carouselSlider } from './frontend/slideshow';
import { readMore } from './frontend/readMore';
import { lightbox } from './frontend/lightbox';
import { videolink } from './frontend/videolink';
import { validateForm } from './frontend/validateForm';
import { recommendationForm } from './frontend/recommendationForm';

window.$ = window.jQuery = $;

$(document).ready(function () {
    $('html').removeClass('no-js').addClass('js');
    // Polyfill: object-fit
    objectFitImages();
    // Check if user scrolled
    const scrollPage = $('body').find('.ghwp-header-scroll');
    if (scrollPage) {
        navScroll();
    }
    // Navigation: small screen toggle
    navToggle();
    // Navigation: dropdown
    navDropdown();
    navDropdown('#ghwp-b2b-nav');
    // Collapsibles
    showHide();
    // Tabs
    tabs();
    // Parallax sections
    const parallaxImages = document.getElementsByClassName(
        'ghwp-parallax-image'
    );
    if (parallaxImages.length > 0) {
        new simpleParallax(parallaxImages, {
            scale: 1.5,
        });
    }
    // Init pretty name scrolling on hash change and load
    scrollToPrettyNameElementOrChild();
    // Start slideshows
    stageSlider();
    carouselSlider();
    readMore();
    // Open linked images in lightbox
    lightbox();
    // Open linked videos in lightbox
    videolink();
    // Validate forms
    const hasForm = $('body').find('#ghwp-contactform');
    if (hasForm.length > 0) {
        validateForm();
    }
    // Recommendation forms
    recommendationForm();
});
